// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__3GIrq","content":"styles_content__33KpT","intro":"styles_intro__3pTQA"};